import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BILLING_LOGS } from "./apiRoutes";

interface UseGetBillingLogsListProps {
  data: any;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBillingLogsList = async (communityId: string, data: any) =>
  await axiosAuth.post(`${BILLING_LOGS(communityId)}/grid`, data);

const useGetBillingLogsList = ({
  data,
  communityId,
  queryParams,
}: UseGetBillingLogsListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["billing-logs"],
    queryFn: () => getBillingLogsList(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetBillingLogsList;
